import { ref } from "vue";
import useWooCart from "./useWooCart";
import useWooCheckout from "./useWooCheckout";

const step = ref(1);
const wooCart = useWooCart();
const wooCheckout = useWooCheckout();

export default function (){

	return {
		step,
		wooCart,
		wooCheckout
	}
}